import Api from "./base/api-base";

export default class AggregateApi {
  // 集計費目マスタ一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.aggregate
    });
  }

  // 集計費目マスタ登録
  store(params) {
    return Api.post({
      endpoint: Api.endpoint.aggregate,
      params: params
    });
  }

  // 集計費目マスタ情報取得
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.aggregate,
      id: id
    });
  }

  // 集計費目マスタ更新
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.aggregate,
      id: id,
      params: params
    });
  }

  // 集計費目マスタ削除
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.aggregate,
      id: id
    });
  }
}
